import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { REVIEWS, reviewsAggregate } from "@/data/reviewsData";
import { caseStudyForReview } from "@/data/caseStudies";

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={14} fill={i <= n ? "var(--red)" : "none"} className={i <= n ? "text-[var(--red)]" : "text-[var(--text-muted)]"} />)}
  </div>
);

export const ReviewsBlock = () => {
  const agg = reviewsAggregate();
  if (!agg) return null;
  return (
    <section data-testid="reviews-section" className="py-24">
      <div className="shg-container">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="section-tag mb-4"><span className="dot" />Client reviews</div>
            <h2 className="font-display text-4xl md:text-5xl leading-[0.95]">Rated {agg.ratingValue}/5 by {agg.reviewCount} exhibitors.</h2>
          </div>
          <Stars n={Math.round(agg.ratingValue)} />
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-5">
          {REVIEWS.map((r, i) => (
            <figure key={i} data-testid={`review-${i}`} className={`shg-card p-6 flex flex-col lg:col-span-2 ${REVIEWS.length === 5 && i === 3 ? "lg:col-start-2" : ""} ${REVIEWS.length % 2 === 1 && i === REVIEWS.length - 1 ? "md:col-span-2 lg:col-span-2" : ""}`}>
              <Stars n={r.rating} />
              <blockquote className="text-[var(--text-soft)] text-[15px] leading-relaxed mt-4 mb-5">“{r.text}”</blockquote>
              <figcaption className="text-sm"><span className="font-medium">{r.author}</span>{r.company ? `, ${r.company}` : ""}<div className="text-xs text-[var(--text-muted)] mt-1">{r.expo}</div></figcaption>
              {caseStudyForReview(i) && <Link to={`/case-studies/${caseStudyForReview(i).slug}`} data-testid={`review-case-link-${i}`} className="inline-block mt-auto pt-4 text-sm text-[var(--red)]">Read the case study →</Link>}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsBlock;
